import { FC, useState } from "react";
import { useVerifyEmailMutation } from "@entities/Shop/api/shopApiSlice";
import { Modal } from "@shared/ui/Modal/Modal";
import styles from "./styles.module.css";

interface EmailVerificationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

export const EmailVerificationModal: FC<EmailVerificationModalProps> = ({
  isOpen,
  onClose,
  onSuccess,
}) => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [verifyEmail, { isLoading }] = useVerifyEmailMutation();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");

    if (!email) {
      setError("Пожалуйста, введите email");
      return;
    }

    try {
      const response = await verifyEmail({ email }).unwrap();
      if (response.success) {
        onSuccess();
        onClose();
      } else {
        setError(response.message || "Произошла ошибка при отправке кода");
      }
    } catch (err: any) {
      console.error('Email verification error:', err);
      if (err.data?.message) {
        setError(err.data.message);
      } else if (err.error) {
        setError(err.error);
      } else {
        setError("Произошла ошибка при отправке кода. Пожалуйста, попробуйте позже.");
      }
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className={styles.emailModal}>
        <button className={styles.closeButton} onClick={onClose}>
          <img src="/landing/Close.svg" alt="Закрыть" />
        </button>
        <div className={styles.emailContent}>
          <h2 className={styles.emailTitle}>Подтверждение Email</h2>
          <p className={styles.emailDescription}>
            Для продолжения покупки необходимо подтвердить ваш email адрес.
            Мы отправим вам ссылку для подтверждения.
          </p>
          <form onSubmit={handleSubmit}>
            <input
              type="email"
              placeholder="Введите ваш email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={isLoading}
              className={styles.emailInput}
            />
            {error && <p className={styles.error}>{error}</p>}
            <button
              type="submit"
              disabled={isLoading}
              className={styles.submitButton}
            >
              {isLoading ? "Отправка..." : "Отправить код"}
            </button>
          </form>
        </div>
      </div>
    </Modal>
  );
}; 